// Apple `global-nav` — black 44px ultra-thin bar, persistent.
import type { Route } from "../App";

const NAV_ITEMS: { key: Route; label: string }[] = [
  { key: "home", label: "Hôm nay" },
  { key: "trends", label: "Trend" },
  { key: "ask", label: "Hỏi BS" }
];

export function GlobalNav({
  onNavigate,
  active
}: {
  onNavigate: (r: Route) => void;
  active: Route;
}) {
  return (
    <nav className="sticky top-0 z-50 h-11 bg-black text-white">
      <div className="mx-auto flex h-full max-w-[1440px] items-center justify-between px-6">
        <button
          onClick={() => onNavigate("home")}
          className="apple-press text-finePrint tracking-tight"
          aria-label="Home"
        >

        </button>
        <ul className="hidden items-center gap-7 md:flex">
          {NAV_ITEMS.map((item) => (
            <li key={item.key}>
              <button
                onClick={() => onNavigate(item.key)}
                className={`apple-press text-finePrint transition-opacity ${
                  active === item.key ? "opacity-100" : "opacity-72 hover:opacity-100"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
        <button
          onClick={() => onNavigate("settings")}
          className="apple-press text-finePrint opacity-72 hover:opacity-100"
          aria-label="Settings"
        >
          Cài đặt
        </button>
      </div>
    </nav>
  );
}
